/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020-2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.modalModule')
  .service('BulbUseTemplateModalService', ['$location', '$translate', '$state', '$window', 'AeroDialogService', 'AnalyticsService', 'BulbAuthService', BulbUseTemplateModalService])
  .constant('USE_TEMPLATE_TIMEOUT', 30000); // This is the timeout time for the error modal to popup if template does not get copied in 30 sec.

function BulbUseTemplateModalService($location, $translate, $state, $window, AeroDialogService, AnalyticsService, BulbAuthService) {
  /**
     * @desc Use template modal showing copying template error message.
     *
   * @param event event triggered.
   * @param modalBodyKey locale code which need to be translated.
   * @param hideOkButton whether to hide Ok button.
   * @param showUnsupportedCopyModal whether to show unsupported copy template error modal.
   */
  this.showErrorModal = function (event, modalBodyKey, hideOkButton, showUnsupportedCopyModal) {
    AeroDialogService.showDialog({
      icon: 'fas fa-exclamation-triangle',
      iconClass: 'aero-alert',
      title: $translate.instant(showUnsupportedCopyModal
        ? 'use_template_template_not_copied' : 'use_template_error_modal_title'),
      detail: $translate.instant(modalBodyKey || 'use_template_error_modal_body'),
      primaryLabel: $translate.instant(showUnsupportedCopyModal ? 'button_ok' : 'use_template_error_modal_button'),
      showSecondary: false,
      focusAfterClosed: event ? event.currentTarget : null,
      keyboard: true,
    });
  };

  /**
     * @desc Use template modal showing copying template message.
   */
  this.useTemplateCopyingModal = function () {
    return AeroDialogService.showDialog({
      headerTemplate: '<img src="resources/images/bulb-loading-circle.gif"/>',
      title: $translate.instant('pageview_template_modal_title'),
      detail: $translate.instant('use_template_copying_modal_body'),
      primaryLabel: $translate.instant('use_template_copied_modal_continue_button'),
      showSecondary: false,
      closeOnPrimary: false,
      onPrimary: (dialogRef) => {
        dialogRef.close();
      }
    });
  };

  /**
   * @desc Use template modal showing template copied message.
   *
   * @param event event triggered
   * @param unitid unit id of use template either from page or collection.
   * @param copyType shows the type of template.
   *
   */
  this.useTemplateCopiedModal = function (event, unitid, copyType) {
    AeroDialogService.showDialog({
      icon: 'far fa-check',
      title: $translate.instant('use_template_copied_modal_title'),
      detail: $translate.instant('use_template_copied_modal_body'),
      primaryLabel: $translate.instant('use_template_copied_modal_continue_button'),
      showSecondary: false,
      focusAfterClosed: event.currentTarget,
      onPrimary: () => {
        const eventObject = {
          event: 'TemplateCopyEvent',
          copiedUnitId: unitid,
          copyToUserId: BulbAuthService.currentUser.id,
          copyType,
        };
        AnalyticsService.pushEvent(eventObject);
        $location.path(`/${BulbAuthService.currentUser.username}`);
      },
    });
  };

  /**
     * @desc Use template modal for unauthenticated user telling to sign in first.
   */
  this.useTemplateSigninModal = function () {
    AeroDialogService.showDialog({
      icon: 'fas fa-user',
      title: $translate.instant('use_template_signin_modal_title'),
      detail: $translate.instant('use_template_signin_modal_body'),
      primaryLabel: $translate.instant('sign_in_button'),
      onPrimary: () => {
        $state.go('signIn', { targetUrl: $window.location.href, referrer: 'copy-template' });
      },
    });
  };
}
